import buildGarden from "@/utils/buildGarden";
import dateFormats from "@/utils/dateFormats";
interface Data {
  type: string;
  vendor: string;
  premium: boolean;
  progress: string;
  date?: string;
  cardGarden: Array<any>;
}

const iconLimit: number = 4;

function returnType(cType: string): string {
  let rtn = "";
  const path = "learning-path";
  const videoSeries = "video-series";
  const ilt = "instructor-led";
  switch (cType) {
    case "webinar":
      rtn = "virtual-event";
      break;
    case "videoSeries":
    case "track":
    case videoSeries:
    case "video-track":
      rtn = videoSeries;
      break;
    case "challenge":
    case "exam-voucher":
    case "tutorial":
    case "practice-exam":
    case "bundle":
    case "lab":
    case "graded-lab":
    case "video":
    case "podcast":
    case "course":
    case "scorm":
    case ilt:
      rtn = cType;
      break;
    case "path":
    default:
      rtn = path;
  }
  return rtn;
}
function checkPremium(id: string, list: Array<string>): boolean {
  return !list.includes(id);
}
function getVendor(publisher_name: string): string {
  if (publisher_name?.length) {
    return publisher_name?.toLocaleLowerCase() ?? "";
  }
  return "";
}
function getEventDate(event_date: string): string {
  if (event_date) {
    return (
      dateFormats.shortFmt(event_date) + " " + dateFormats.dayFmt(event_date)
    );
  }
  return "";
}
const newCard = {
  dataObject: (content: any, status: any, isStoreCard?: boolean) => {
    const garden = buildGarden(content, iconLimit, isStoreCard);
    // For bundles, override vendor to show "BUNDLE" text
    let vendor = getVendor(content?.publisher_name);
    if (
      content?.type === "bundle" ||
      content?.catalog_data?.type === "bundle"
    ) {
      vendor = "BUNDLE";
    }

    // Get the base type first
    let contentType = returnType(content?.type);

    // For graded labs, override type to show "graded-lab"
    if (content?.type === "lab" && content?.lab_type === "graded-labs") {
      contentType = "graded-lab";
    }

    // if bundle, modify type based on catalog_data.length or contents.length
    if (contentType === "bundle") {
      const bundleLength =
        content?.catalog_data?.length || content?.contents?.length || 0;
      if (bundleLength === 1) {
        contentType = "bundle";
      } else if (bundleLength === 2) {
        contentType = "bundle-2";
      } else if (bundleLength >= 3) {
        contentType = "bundle-3";
      }
    }

    return {
      type: contentType,
      vendor: vendor,
      premium: checkPremium(content?.guid, status?.userEntitlements ?? []),
      progress: content?.progress,
      date: getEventDate(content?.event_date),
      cardGarden: garden,
    } as Data;
  },
};
export default newCard;
